import { useMemo } from 'react';

interface RowData {
  Id: string | number | undefined;
}

type SetShowPopup = (show: boolean) => void;

export const useCustomEdit = (rowData: RowData, setShowPopup: SetShowPopup) => {
  const handleEdit = useMemo(() => {
    if (rowData?.Id === undefined) {
      return () => {};
    }

    return () => setShowPopup(true);
  }, [rowData]);

  return handleEdit;
};
